"use strict";

define(function (require, exports, module) {

    /**
     * @file 合并参数
     * @author 子虔
     * @date    2014-08-15 17:43:36
     * @param  {Object}  to - 源
     * @param  {Object}  from - 要处理的对象
     */

    module.exports = function parseParam(to, from) {
        var key,
            obj = {};

        from = from || {};

        for (key in to) {
            if (to.hasOwnProperty(key)) {
                obj[key] = to[key];
                if (from[key] != null) {
                    if (from.hasOwnProperty(key)) {
                        if ($.isPlainObject(obj[key]) && $.isPlainObject(from[key])) {
                            obj[key] = parseParam(obj[key], from[key]);
                        } else {
                            obj[key] = from[key];
                        }
                    }
                }
            }
        }

        return obj;
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/parse-param.js
// module id = 716
// module chunks = 0